import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { visitsKeys } from '../../api/query-keys/visits';

import { visitsApi } from '@/features/visits/api/lib/visits';
import { ParkingTicket } from '@/features/visits/api/types/visits';
import { ApiError } from '@/types/interfaces/api-error';

export const useSettleParkingTicket = (onSuccess?: (ticket: ParkingTicket) => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(['visit']);

  return useMutation({
    mutationFn: ({ visitorId, ticketNumber }: { visitorId: number; ticketNumber: number }) =>
      visitsApi.settleParkingTicket(visitorId, ticketNumber),
    retry: false,
    onSuccess: ticket => {
      queryClient.invalidateQueries({ queryKey: visitsKeys.all });
      onSuccess?.(ticket);
    },
    onError: (error: ApiError) => {
      queryClient.invalidateQueries({ queryKey: visitsKeys.all });

      if (error?.response?.status === 404) {
        toast.error(t('visit:modal.ticketNotFound'));
        return;
      }

      toast.error(error?.response?.data?.message);
    },
  });
};
